/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BadgeAchievementReward = {
    type: BadgeAchievementReward.type;
    badgeId: number;
};
export namespace BadgeAchievementReward {
    export enum type {
        BADGE = 'badge',
    }
}

